import * as React from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import './user-list.styles.scss';

import ErrorMessage from '../../components/error/error.component';
import Spinner from '../../components/spinner/spinner.component';
import GeneralConstants from '../../constants/general.constants';
import NotFound from '../not-found/not-found.component';

import api from '../../services/api.service';

class UserList extends React.Component {
    state = {
        users: [],
        error: null,
        errorMessage: '',
        isFetching: true,
        sortField: null,
        sortDirection: 'asc'
    };

    async componentDidMount() {
        try {
            const users = await api.users.get('?includes=currentrole');
            this.setState({
                users: users,
                isFetching: false,
                error: false
            });
        } catch (error) {
            this.setState({
                isFetching: false,
                error,
                errorMessage: true
            });
        }
    }

    handleSort = (field) => {
        const { sortField, sortDirection, users } = this.state;
        const newDirection = field === sortField && sortDirection === 'asc' ? 'desc' : 'asc';
        
        const sortedUsers = [...users].sort((a, b) => {
            let aValue = (a[field] || '').toLowerCase();
            let bValue = (b[field] || '').toLowerCase();
            
            // Special handling for currentrole
            if (field === 'currentrole') {
                aValue = (a.currentrole?.name || '').toLowerCase();
                bValue = (b.currentrole?.name || '').toLowerCase();
            }
            
            if (newDirection === 'asc') {
                return aValue.localeCompare(bValue);
            }
            return bValue.localeCompare(aValue);
        });

        this.setState({
            users: sortedUsers,
            sortField: field,
            sortDirection: newDirection
        });
    };

    render() {
        const { isFetching, errorMessage, users, sortField, sortDirection } = this.state;

        const getSortIcon = (field) => {
            if (sortField !== field) return '⇅';
            return sortDirection === 'asc' ? '↑' : '↓';
        };

        return (
            <div className='project-data-container'>
                {isFetching && (
                    <CSSTransition in={isFetching} appear timeout={{ appear: 300, exit: 150 }}>
                        <Spinner />
                    </CSSTransition>
                )}
                
                {this.state.error?.http_code === 404 ? (
                    <NotFound />
                ) : (
                    errorMessage && (
                        <ErrorMessage errorID={this.state.error?.id || this.state.error?.status} />
                    )
                )}

                <div className='title-container'>
                    <h1>{GeneralConstants['edit_users']}</h1>
                    <Link to="/admin-user/0" className="btn btn-primary">
                        {GeneralConstants['create_user']}
                    </Link>
                </div>

                <nav className='project-nav'>
                    <NavLink to='/' className='project-nav--home' />
                    <NavLink to='/admin-user' className='admin-nav--user' activeClassName='admin-nav--active'>
                        {GeneralConstants['edit_users']}
                    </NavLink>
                    <NavLink to='/admin-form' className='admin-nav--form' activeClassName='admin-nav--active'>
                        {GeneralConstants['edit_form_data']}
                    </NavLink>
                </nav>

                <div className='project-log-list'>
                    <table className='project-log'>
                        <thead>
                            <tr>
                                <th onClick={() => this.handleSort('firstname')} style={{ cursor: 'pointer' }}>
                                    {GeneralConstants['first_name']} {getSortIcon('firstname')}
                                </th>
                                <th onClick={() => this.handleSort('lastname')} style={{ cursor: 'pointer' }}>
                                    {GeneralConstants['last_name']} {getSortIcon('lastname')}
                                </th>
                                <th onClick={() => this.handleSort('phone')} style={{ cursor: 'pointer' }}>
                                    {GeneralConstants['phone']} {getSortIcon('phone')}
                                </th>
                                <th onClick={() => this.handleSort('email')} style={{ cursor: 'pointer' }}>
                                    {GeneralConstants['email']} {getSortIcon('email')}
                                </th>
                                <th onClick={() => this.handleSort('currentrole')} style={{ cursor: 'pointer' }}>
                                    Aktiv rolle {getSortIcon('currentrole')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {users && users.length > 0 && users.map((user) => (
                                <tr 
                                    key={user.id} 
                                    onClick={() => this.props.history.push(`/admin-user/${user.id}`)}
                                    className="clickable-row"
                                >
                                    <td>{user.firstname}</td>
                                    <td>{user.lastname}</td>
                                    <td>{user.phone || '-'}</td>
                                    <td>{user.email}</td>
                                    <td>{user.currentrole?.name || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default UserList;
